export { default as getActions } from './getActions'
export { default as getCountSliders } from './getCountSliders'
export { default as setEvents } from './setEvents'
